import { useEffectWithErrorLogging } from 'src/utils/useEffectWithErrorLogging';

export function useCalendarPopoverClickHandler(calendarRef, dateSelectorPopUpClose) {
    useEffectWithErrorLogging(() => {
        const handler = (e) => {
            if (
                calendarRef &&
                calendarRef.current &&
                calendarRef.current.contains(e.target)
            ) {
                return;
            }
            dateSelectorPopUpClose();
        };
        document.addEventListener('mousedown', handler);
        document.addEventListener('touchstart', handler);
        return () => {
            document.removeEventListener('mousedown', handler);
            document.removeEventListener('touchstart', handler);
        };
    }, [calendarRef, dateSelectorPopUpClose]);
}
